<template>
  <div id="Client" class="fit q-px-md">
    <crud-layout
      ref="crudLayout"
      :name="nmName"
      :interface="nmInterface"
      :id="id"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import ClientPage from './ClientPage'
const { CrudLayout } = JtCrud

@Component({
  name: 'Client',
  components: { CrudLayout, ClientPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Client extends Vue {
  URL_REGISTER_CLIENT = 'clientRegisterPage'
  NAME_LINK_REGISTER_CLIENT = 'clientRegister'

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ClientPage
  }

  get nmName () {
    return this.name || 'Gerenciar Cliente'
  }

  modify ({ button, params, page, controller }) {
    this.$router.push({
      name: 'clientPage',
      params: {
        reload: true,
        link: 'clientPage',
        ...params,
        name: params.person_name
      },
      force: true,
      reload: true
    })
  }

  mounted () {
    try {
      if (this.$route.name === this.URL_REGISTER_CLIENT) {
        this.$router.push({
          name: this.NAME_LINK_REGISTER_CLIENT,
          params: {
            reload: true,
            link: this.NAME_LINK_REGISTER_CLIENT
          },
          force: true,
          reload: true
        })
      }
      this.$refs.crudLayout.onButton('icAlterar', this.modify)
    } catch (error) {
      console.error(error)
    }
  }
}
export default Client
</script>
<style lang="stylus" scoped></style>
